import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { createPortal } from "react-dom";
import { getCarrinho } from '../../redux/cartReducer';
import { getUsersLists } from '../../redux/userReducer';
import SidebarProfile from '../SidebarProfile/SidebarPorfile';
import FloatingCartButton from '../FloatingCartButton';
import Cart from "../Cart";
import Login from '../../pages/Login/Login';
import RegisterUser from '../../pages/RegisterUser';
import logo from './../../assets/images/estilizado.png';

export default function NavMenu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showModalCart, setShowModalCart] = useState(false);
  const [showModalMenu, setShowModalMenu] = useState(false);
  const [showModalProfil, setShowModalProfil] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showSearchMobile, setShowSearchMobile] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const sacola = useSelector(state => state.cartReducer);
  const usuario = useSelector(state => state.userReducer);

  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const idUser = localStorage.getItem('idUser');
  //const userConnect = usuario.items?.find(el => el.id_usuario === idUser);

  useEffect(() => {
    if (sacola === undefined) dispatch(getCarrinho());
   // if (usuario.items === undefined) dispatch(getUsersLists());
  }, [dispatch]);

  useEffect(() => {
    const closeOnScroll = () => setShowModalProfil(false);
    window.addEventListener('scroll', closeOnScroll);
    return () => window.removeEventListener('scroll', closeOnScroll);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    navigate('/');
    setShowModalProfil(false);
  };

  const closeMobileMenu = () => setShowModalMenu(false);

  return (
    <>
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="flex items-center justify-between px-4 py-3 max-w-screen-xl mx-auto">
          <a href="/" className="w-28">
            <img src={logo} alt="logo congolinaria" className="h-12 object-contain" />
          </a>

          <nav className="hidden lg:flex gap-6 text-lg font-medium text-gray-700">
            {[{ label: 'Início', href: '/' }, { label: 'Loja', href: '/loja-congo' }, { label: 'Cardápio', href: '/redirect_cardapio/' }, { label: 'VegFest 2024', href: '/vegFest/' }, { label: 'Receitas', href: '/receitas' }, { label: 'Contato', href: '/contato' }, { label: 'Sobre', href: '/sobre' }, { label: 'Blog', href: '/blog' }, { label: 'Orçamento', href: '/#order' }].map((link, i) => (
              <a key={i} href={link.href} className="hover:text-yellow-600 transition-colors duration-200">{link.label}</a>
            ))}
          </nav>

          <div className="flex items-center gap-4 text-gray-700">
            <div className="hidden lg:block">
              <input
                type="search"
                placeholder="Pesquisar aqui"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                className="p-2 border rounded"
              />
            </div>

            <button type="button" className="lg:hidden" onClick={() => setShowSearchMobile(true)}>
              <i className="fas fa-search text-xl"></i>
            </button>

            <button className="lg:hidden" onClick={() => setShowModalMenu(!showModalMenu)}>
              <i className="fas fa-bars text-xl"></i>
            </button>

            {isLoggedIn ? (
              <>
                <button onClick={() => { setShowModalCart(!showModalCart); setShowModalProfil(false); }} className="relative">
                  <i className="fas fa-shopping-cart text-xl"></i>
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full px-1">0</span>
                </button>
                <i className="fas fa-user text-xl cursor-pointer" onClick={() => setShowModalProfil(!showModalProfil)}></i>
              </>
            ) : (
              <>
                <span className="cursor-pointer hover:text-yellow-600" onClick={() => setShowLogin(true)}>Entrar</span>
                <span className="cursor-pointer hover:text-yellow-600" onClick={() => setShowRegister(true)}>Cadastrar</span>
              </>
            )}
          </div>
        </div>
      </header>

      {showSearchMobile && (
        <form className="fixed top-16 left-0 w-full bg-white shadow-md p-4 z-50 lg:hidden animate-fade-in-down">
          <div className="flex items-center gap-2">
            <input
              type="search"
              placeholder="Pesquisar aqui"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="flex-1 p-2 border rounded"
            />
            <i
              className="fas fa-times text-xl cursor-pointer"
              onClick={() => setShowSearchMobile(false)}
            ></i>
          </div>
        </form>
      )}

      <AnimatePresence>
      {showModalMenu && (
        <>
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-40 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeMobileMenu}
          />
        <motion.div
          initial={{ x: '-100%' }}
          animate={{ x: 0 }}
          exit={{ x: '-100%' }}
          transition={{ duration: 0.3 }}
          className="lg:hidden fixed left-0 top-0 z-50 bg-white w-80 h-screen flex flex-col shadow-xl">
          <div className="flex justify-end p-4">
            <i className="fas fa-times text-2xl cursor-pointer" onClick={closeMobileMenu}></i>
          </div>
          <nav className="flex flex-col gap-4 p-6 text-xl text-gray-800">
            {[{ label: 'Início', href: '/' }, { label: 'Loja', href: '/loja-congo' }, { label: 'Cardápio', href: '/redirect_cardapio/' }, { label: 'Receitas', href: '/receitas' }, { label: 'Contato', href: '/contato' }, { label: 'Sobre', href: '/sobre' }, { label: 'Blog', href: '/blog' }, { label: 'Orçamento', href: '/#order' }].map((link, i) => (
              <a key={i} href={link.href} onClick={closeMobileMenu} className="hover:text-yellow-600 transition-colors duration-200">
                {link.label}
              </a>
            ))}
          </nav>
        </motion.div>
        </>
      )}
      </AnimatePresence>

      {showLogin && <Login onClose={() => setShowLogin(false)} />}
      {showRegister && <RegisterUser onClose={() => setShowRegister(false)} />}
      {showModalProfil && <SidebarProfile nomeUser={{/*userConnect?.nome*/}} handleLogout={handleLogout} toggleModalProfil={() => setShowModalProfil(false)} />}
      {showModalCart && createPortal(<Cart sacola={sacola.items} onClose={() => setShowModalCart(false)} />, document.body)}
    </>
  );
}
